import { _getInstance } from "@statsig/react-bindings";
import type { StatsigClient } from "@statsig/react-bindings";
import { STATSIG_SDK_KEY } from "./statsig.constants";

// Statsig gate that forces full-page ("hard") navigation for in-app links so
// every navigation re-enters the storefront-traffic-bridge edge router instead
// of Gatsby's client-side router.
export const HARD_NAV_GATE = "marketing_frontend_hard_nav";

// Imperative gate check, usable outside React. The gatsby-browser click
// interceptor and the Algolia autocomplete result render both run outside the
// app's StatsigProvider, so a hook (useGateValue) isn't available there. We read
// the client the StatsigProvider created straight from the SDK's instance
// registry. Falls back to false — i.e. current client-side routing — whenever
// the client is absent (SSR/crawler/keyless env) or the gate is unresolved, so
// the gate off state is exactly today's behavior.
export const isHardNavEnabled = (): boolean => {
  if (!STATSIG_SDK_KEY) return false;
  const client = _getInstance(STATSIG_SDK_KEY) as StatsigClient | undefined;
  return client?.checkGate(HARD_NAV_GATE) ?? false;
};
